import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface InputNumberModalData {
  title?: string;
  message: string;
  placeholder?: string;
  min?: number;
  max?: number;
  defaultValue?: number;
  unitOfMeasure?: string;
}

@Component({
  selector: 'app-input-number-modal',
  templateUrl: './input-number-modal.component.html',
  styleUrls: ['./input-number-modal.component.scss']
})
export class InputNumberModalComponent implements OnInit {
  public inputValue: number | null;

  constructor(
    public dialogRef: MatDialogRef<InputNumberModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputNumberModalData
  ) {
    this.inputValue = data.defaultValue || null;
  }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.isValid()) {
      this.dialogRef.close(this.inputValue);
    }
  }

  isValid(): boolean {
    if (this.inputValue === null || this.inputValue === undefined) {
      return false;
    }

    if (this.data.min !== undefined && this.inputValue < this.data.min) {
      return false;
    }

    if (this.data.max !== undefined && this.inputValue > this.data.max) {
      return false;
    }

    return true;
  }
}
